import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import '../styles/landing.css';
import { Header } from '../landing/Header';
import { Footer } from '../landing/Footer';
import { Pricing } from '../landing/Pricing';
import { FAQ } from '../landing/Faqs';
import { SignupModalProvider } from '../landing/SignupModalContext';

const LANDING_BG = '#3B4F5E';
const canonicalUrl = 'https://www.smilesflow.com/pricing';
const ogImage = 'https://www.smilesflow.com/og-image.png';

const TITLE = 'SmilesFlow Pricing | Free to build, £39 to publish';
const DESCRIPTION = 'Free to build and preview branded mini-games. £39 per published game, or £149 for a 5-game pack. No subscription, no tiers, every feature unlocked.';

export default function PricingPage() {
  useEffect(() => {
    document.body.style.backgroundColor = LANDING_BG;
    return () => { document.body.style.backgroundColor = ''; };
  }, []);

  return (
    <SignupModalProvider>
    <div className="landing-page min-h-screen flex flex-col bg-gch-bg text-white antialiased">
      <Helmet>
        <title>{TITLE}</title>
        <meta name="description" content={DESCRIPTION} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:title" content={TITLE} />
        <meta property="og:description" content={DESCRIPTION} />
        <meta property="og:image" content={ogImage} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={TITLE} />
        <meta name="twitter:description" content={DESCRIPTION} />
        <meta name="twitter:image" content={ogImage} />
      </Helmet>
      <Header />
      <main className="relative pt-20">
        <Pricing />
        <FAQ />
      </main>
      <Footer />
    </div>
    </SignupModalProvider>
  );
}
